import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  type SetFirmwareAdminSettingsParams,
  setFirmwareAdminSettings,
} from 'api/admin/firmware/firmware';

export const useSetFirmwareAdminSettings = ({
  successCallback,
}: {
  successCallback?: () => void;
} = {}) => {
  return useMutation<unknown, AxiosError<{ error: string }>, SetFirmwareAdminSettingsParams>({
    mutationFn: async ({ defaultReleases }: SetFirmwareAdminSettingsParams) => {
      return setFirmwareAdminSettings({ defaultReleases });
    },
    onSuccess: () => {
      successCallback?.();
      toaster.success('Global default firmware releases updated.');
    },
    onError: (error) => {
      Sentry.captureException(error);

      toaster.error(
        error?.response?.data?.error ?? 'Failed to update global default firmware releases',
      );
    },
  });
};
